module.exports = __webpack_public_path__ + "static/Young_Beatrix_Potter_Dog-68a233ea309e6525c56992eb829cd00c.jpg";